import { DateTime } from "luxon";
import { EMPTY_VALUE } from '@src/core/config';

export const arcDateWithTime = (date?: string) => {
  if (!date || typeof date !== 'string') return EMPTY_VALUE;
  return DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_MED);
};